export enum CustomButtonEvent {
    PRIMARY_BUTTON_CLICK = "Primary Button Click",
    DISCLOSURE_BUTTON_CLICK =  "Disclosure Button Click"
}